var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3728 6.51562L10.9997 9.8887L7.62662 6.51562L6.51562 7.62662L9.8887 10.9997L6.51562 14.3728L7.62662 15.4838L10.9997 12.1107L14.3728 15.4838L15.4838 14.3728L12.1107 10.9997L15.4838 7.62662L14.3728 6.51562Z",
    fill: "#8F96A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92564 0 0 4.92564 0 11C0 17.0744 4.92564 22 11 22C17.0744 22 22 17.0744 22 11C22 4.92564 17.0744 0 11 0ZM11 20.4286C5.80093 20.4286 1.57143 16.1991 1.57143 11C1.57143 5.80093 5.80093 1.57143 11 1.57143C16.1991 1.57143 20.4286 5.80093 20.4286 11C20.4286 16.1991 16.1991 20.4286 11 20.4286Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/incorrect.a2095a07f4e2b38bd5a4a84d6ff96788.svg";
export { ForwardRef as ReactComponent };